import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'sanitizeHtml'
})
export class SanitizeHtmlPipe implements PipeTransform {

  constructor(private _sanitizer: DomSanitizer) {
  }

  transform(html: string): SafeHtml {
    html = this.patchYoutube(html);

    return this._sanitizer.bypassSecurityTrustHtml(html);
  }

  // this enables the youtube js api to obtain the playing status of videos within the app
  private patchYoutube(html: string) {
    const youtubeLinkRegex = new RegExp(/src="https:\/\/www\.youtube\.com\/embed\/([0-9A-Za-z_-]+)"/g);

    html = html?.replace(youtubeLinkRegex, 'src="https://www.youtube.com/embed/$1?enablejsapi=1"');

    return html;
  }
}
